/**
 * @param {string|number} ssn
 * @returns {undefined|number}
 */
function getAgeFromSsn (ssn) {
  if (!ssn) return

  // Trim value
  let val = ssn
    .toString()
    .trim()

  // Remove all characters except numbers
  val = val.replace(/[^0-9]/g, '')
  if (val.length !== 11) return

  const individualNumber = val.substring(6, 9)
  let year = val.substring(4, 6)
  const month = val.substring(2, 4)
  const day = val.substring(0, 2)

  if (month < 1 || month > 12) return
  if (day < 1 || day > 71) return

  if (individualNumber >= 500) {
    year = `20${year}`
  } else {
    year = `19${year}`
  }

  const currentDate = new Date()
  const birthDate = new Date(parseInt(year, 10), (month - 1), parseInt(day, 10))
  const timeDiff = Math.abs(currentDate.getTime() - birthDate.getTime())
  const ageDate = new Date(timeDiff)

  return Math.abs(ageDate.getUTCFullYear() - 1970)
}

module.exports = { getAgeFromSsn }
